import Context from "./context";
import { cancel_translate, insert_translate, qry_translate, Translate } from "../db/t_translate";
import { msg_update_meta } from "../db/t_msg";

export default class TranslateController {

    public static async qryTranslateLocal(ctx: Context, mid: string): Promise<{
        error?: any,
        data?: string
    }> {
        const r = await qry_translate(ctx.db, mid)
        if (r.data) {
            const desc = r.data.desc
            if (desc && desc.length > 0) {
                return { data: desc }
            }
        }
        return { error: r.error }
    }

    public static async cancelTranslateLocal(ctx: Context, mid: string,meta:any): Promise<{ error?: any }> {
        const r = await cancel_translate(ctx.db, mid)
         meta.hasTranslate=''
        await msg_update_meta(ctx.db, mid, meta)
        return { error: r.error }
    }

    public static async qryTranslate(ctx: Context, mid: string, msg: string, to: string, meta: any): Promise<{
        error?: any,
        data?: string
    }> {
        const r = await this.qryTranslateLocal(ctx, mid)
        if (r.data && r.data.length > 0) {
            return { data: r.data }
        }
        const notEmojiMsg = this.removeEmojis(msg)
        const r1 = await ctx.conn.Call("/v1/sdk/msg/translate", { mid: mid, to: to, msg: notEmojiMsg });
        if (r1.code === 0 && r1.data) {
            const translate = this.createTranslate(r1.data)
            await insert_translate(ctx.db, translate)
            meta.hasTranslate='1'
            await msg_update_meta(ctx.db, mid, meta)
            return { data: r1.data.desc_content }
        }
        return { error: r1.msg }
    }


    public static createTranslate(data: any): Translate {
        const mid = data.mid
        const src = data.src_content//原来的文本内容
        const desc = data.desc_content//翻译后的文本内容
        return { mid: mid, src: src, desc: desc }
    }

    public static removeEmojis(str: string): string {
        // 定义一个用于匹配所有 emoji 的正则表达式
        const emojiRegex = /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}]/gu;
        // 使用正则表达式替换掉所有的 emoji
        return str.replace(emojiRegex, '');
    }

}